import styled from 'styled-components';

export const Logo = styled.a`
    margin: 20px 0;
    max-width: 100%;
    justify-content: center;
    display: flex; 
    height: 70px;
    @media screen and (max-height: 728px) {
        height: 50px;
    }
    @media screen and (max-width: 859px) {
        width: 100px;
        height: 40px;
        margin: 5px;
    }
`;
export const LogoImg = styled.img<{ maxWidth?: string }>`
    max-width: ${p => p.maxWidth ?? '100px'};
    @media screen and (max-width: 859px) {
        height: 40px;
    }
`;
